import { useMutation } from '@tanstack/react-query';
import { exportTicketsInJudgment } from '../requests/ticketsInJudgment.request';
import { TicketsInJudgmentRequest } from '../types/ticketsInJudgment.types';
import toast from 'react-hot-toast';
import { AxiosError } from 'axios';

export const useExportTicketsInJudgmentMutation = () => {
  return useMutation<void, AxiosError, TicketsInJudgmentRequest>({
    mutationKey: ['export-tickets-in-judgment'],
    mutationFn: exportTicketsInJudgment,
    onError: (error) => {
      toast.error(error.message || 'Failed to export tickets in judgment');
    },
    onSuccess: () => {
      toast.success('Report exported successfully');
    }
  });
};
